import React from "react";
import { useTranslation } from "react-i18next";

import IndiceExplorer from "../Components/indiceExplorer";

import { getFavoriteSymbols, getIndiceDetails } from "../Data/dataApi";
import { Helmet } from "react-helmet-async";

const Favorites: React.FC = () => {

  const { t } = useTranslation();

  const fetchFavorites = async (
    search: string,
    exchange: string,
    sort: string,
    page: number,
    pageSize: number
  ) => {

    const favorites = await getFavoriteSymbols();
    
    const favoritesDetails = await Promise.all(
      favorites.map(symbol => getIndiceDetails(symbol, "favorites"))
    );
    
    return {
      items: favoritesDetails,
      totalPages: 1
    };
  };

  return (
    <>
      <Helmet>
        <title>
          Favorites | Stockifly
        </title>

        <meta
          name="description"
          content="Favorites of stocks"
        />
      </Helmet>

    <div className="page-container">

      <div className="page-header">
        <h1>{t("favorites.title")}</h1>
        <p>{t("favorites.description")}</p>
      </div>

      <IndiceExplorer
        fetchData={fetchFavorites}
        returnUrl="favorites"
      />

    </div>
  </>
  );
};

export default Favorites;